var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 2048,
    width: 2048,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.9882812 1034.5352c-1.8058997 0-3.27539058 1.4694-3.27539058 3.2753v8.961c0 1.8059 1.46949088 3.2754 3.27539058 3.2754h12.0468748c1.8059 0 3.275391-1.4695 3.275391-3.2754v-8.961c0-1.8059-1.469491-3.2753-3.275391-3.2753zm0 1.0332h12.0468748c1.251185 0 2.242188.991 2.242188 2.2421v8.961c0 1.2512-.991003 2.2422-2.242188 2.2422h-12.0468748c-1.2511848 0-2.2421874-.991-2.2421874-2.2422v-8.961c0-1.2511.9910026-2.2421 2.2421874-2.2421z",
    transform: "matrix(96.752895 0 0 96.752895 55.328158 -99820.70216999998)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.705bc31867493b0911109dc0819dde15.svg";
export { ForwardRef as ReactComponent };